import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from '../Modal';
import PasswordForm from '../PasswordForm';
import * as modal from '../../reducers/modalReducer';

class PasswordFormModal extends Component {
    isClosed = false;
    
    onCloseRequest = () => {
      if (this.isClosed) return;
        this.props.hideModal();
    }

    render() {
      return (
        <Modal paddingTop={'65px'} overlayTop={0} closeOnOverlayClick={false} closeOnOutsideClick={false} isOpened={true} onClose={this.onCloseRequest}>
          <PasswordForm onCloseRequest={this.onCloseRequest} />
        </Modal>
      );
    }
}

const mapDispatchToProps = (dispatch) => {
  return { 
    hideModal: () => dispatch(modal.hideModal()),
  };
};

export default connect(null, mapDispatchToProps)(PasswordFormModal);


// WEBPACK FOOTER //
// ./src/components/PasswordFormModal/PasswordFormModal.jsx